<script type="text/jsx">
import BuyNow from './buy-now';
import Edit from './edit.vue';
import Add from "./add2cart";
import Upgrade from './upgrade.vue';
import Pbx2prop from './pbx2prop.vue';
import Downgrade from './downgrade.vue';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['migratePlanState']),
  },
  render() {
    const context = { ...{ props: { ...this.$attrs }, on: { ...this.$listeners } } };
    if (this.$context.is.buyNow || this.$context.is.basic2pro) return <BuyNow {...context} />;
    if (this.$context.is.edit || this.migratePlanState.is.upgrade || this.$context.is.downgrade) {
      if (this.migratePlanState.is.upgrade) return <Upgrade {...context} />;
      if (this.migratePlanState.is.downgrade || this.$context.is.downgrade) return <Downgrade {...context} />;
      return <Edit {...context} />;
    }
    if (this.$context.is.pbx2prop) return <Pbx2prop {...context} />;
    if (this.$context.is.add2cart) return <Add {...context} />;
    return null;
  },
};
</script>
